import Record from '../Record'

export default class Site extends Record {

	static Types = [
		{
			value: 'shop',
			label: 'Bolt',
			icon: 'store-alt'
		},
		{
			value: 'restaurant',
			label: 'Étterem',
			icon: 'concierge-bell'
		},
		{
			value: 'fastfood',
			label: 'Gyorsétterem',
			icon: 'utensils'
		},
		{
			value: 'pizzeria',
			label: 'Pizzéria',
			icon: 'pizza-slice'
		},
		{
			value: 'cafe',
			label: 'Kávézó',
			icon: 'coffee'
		},
		{
			value: 'bar',
			label: 'Bár',
			icon: 'glass-martini-alt'
		},
		{
			value: 'disco',
			label: 'Szórakozóhely',
			icon: 'music'
		},
		{
			value: 'icecream',
			label: 'Fagyizó',
			icon: 'ice-cream'
		},
		{
			value: 'pastry',
			label: 'Cukrászda',
			icon: 'birthday-cake'
		}
	]

	constructor (data) {
		super(data)
		return this._proxy
	}

	static async fetch (company_db_id = null, id = null) {
		if (company_db_id == null || id == null) {
			// Create record
			throw new Error('New site cannot be created')
		} else {
			// Load
			let data = await Anvil.REST.get(`/c_order/site/${company_db_id}/${id}`)
			return new Site(data)
		}
	}

	static async delete (id) {
        throw new Error('Site cannot be deleted')
	}

	async commit () {
		if (this._data.id == null) {
			// Insert
            throw new Error('New site cannot be created')
		} else {
			// Update
			await Anvil.REST.put(`/c_order/site/${this._data.company_db_id}/${this._data.id}`, this._data)
		}
	}
}
